import { boot } from 'quasar/wrappers';
import * as Sentry from '@sentry/browser';
// import { Integrations } from '@sentry/tracing';
import { SENTRY_OPTIONS } from 'PortalDir/constants/app/sentry';

export default boot(({ app }): void => {
  Sentry.init({
    app,
    dsn: SENTRY_OPTIONS.dsn ?? undefined,
    autoSessionTracking: true,
    environment: SENTRY_OPTIONS.environment ?? 'LOCAL_*',
    integrations: [new Sentry.BrowserTracing()],
    tracingOptions: {
      trackComponents: SENTRY_OPTIONS.trackComponents,
    },
    tracesSampleRate: SENTRY_OPTIONS.tracesSampleRate,
  } as Sentry.BrowserOptions);
});
